export interface IMessageParts {
  text: string;
  link?: boolean;
  mail?: boolean;
}

export const getMessageParts = (text: string): IMessageParts[] => {
  let linkParts: IMessageParts[] = [];
  let currentText = text;
  while (currentText.length > 0) {
    const match = currentText.match(/<a>.*<\/a>/);
    if (!match) {
      linkParts.push({
        text: currentText,
      });
      currentText = '';
    } else if (match.index !== undefined) {
      if (match.index > 0) {
        linkParts.push({ text: currentText.substring(0, match.index) });
      }
      linkParts.push({
        text: match[0].replace(/<.?a>/g, ''),
        link: true,
        mail: match[0].includes('@'),
      });
      const matchEnd = match.index + match[0].length;
      currentText =
        currentText.length > matchEnd ? currentText.substring(matchEnd) : '';
    }
  }
  return linkParts;
};
